import { configureStore } from '@reduxjs/toolkit';
// import createSagaMiddleware from 'redux-saga';
import phraseReducer from '../features/phrase/phraseSlice';
import categoryReducer from '../features/category/categorySlice';
import authReducer from '../features/auth/authSlice';
// import rootSaga from './rootSaga';

// const sagaMiddleware = createSagaMiddleware();

export default configureStore({
  reducer: {
    phrase: phraseReducer,
    category: categoryReducer,
    auth: authReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

// sagaMiddleware.run(rootSaga);
